import PersonServer from "../../server/person";
import OutputPerson, { RequestPersonsByGroup } from "../../dtos/person";
import Service, {
  ServiceCreator,
  ServiceDeleter,
  ServiceReader,
  ServiceUpdater,
} from "..";

class PersonServiceReader extends ServiceReader {
  constructor(protected api: PersonServer) {
    super();
  }

  public async byGroup(group: string): Promise<OutputPerson[]> {
    const raw = await this.api.get(new RequestPersonsByGroup(group));
    if (!Array.isArray(raw))
      throw new TypeError("Person list is not an array.");

    return raw.map((value) => OutputPerson.convert(value));
  }
}

class PersonServiceCreator extends ServiceCreator {}
class PersonServiceUpdater extends ServiceUpdater {}
class PersonServiceDeleter extends ServiceDeleter {}

export default class PersonService extends Service {
  constructor() {
    super(new PersonServer());
  }

  public get read(): PersonServiceReader {
    return new PersonServiceReader(this.api as PersonServer);
  }
  public get create(): ServiceCreator {
    return new PersonServiceCreator();
  }
  public get update(): ServiceUpdater {
    return new PersonServiceUpdater();
  }
  public get delete(): ServiceDeleter {
    return new PersonServiceDeleter();
  }
}
